module.exports = __webpack_public_path__ + "img/en.5db9fea0.svg";